angular.
module("digiexam.exam").
directive("examQuestionsSelector", function examQuestionsSelectorDirective() {
	"use strict";

	var directiveName = "examQuestionsSelector";
	var uniqueId = 0;

	function getId(item) {
		return item.id;
	}

	return {
		restrict: "E",
		scope: {
			exam: "=",
			selection: "=",
		},
		templateUrl: "directives/exam-questions-selector.html",
		replace: true,

		link: function link($scope) {
			// TODO(kenneth): Use one-time binding in the template after updating to Angular 1.3
			$scope.directiveId = directiveName + "-" + uniqueId++;
		},
		controller: function controller($scope) {
			$scope.isItemSelected = function isItemSelected(item) {
				return $scope.selection.indexOf(item.id) > -1;
			};

			$scope.areAllItemsSelected = function areAllItemsSelected() {
				return $scope.selection.length === $scope.exam.questions.length;
			};

			$scope.toggleSelectItem = function toggleSelectItem(item) {
				var selection = $scope.selection;

				if ($scope.isItemSelected(item)) {
					selection.splice(selection.indexOf(item.id), 1);
				} else {
					selection.push(item.id);
				}
			};

			$scope.toggleAllItems = function toggleAllItems() {
				if ($scope.areAllItemsSelected()) {
					$scope.selection = [];
				} else {
					$scope.selection = $scope.exam.questions.map(getId);
				}
			};
		},
	};
});
